module.exports = __webpack_public_path__ + "media/assets/svg/illustrations/undraw_circuit_board_4c4d-740e8880ab5bdf831b6f5669a2fa963f.svg";